import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import DemoPreview from './DemoPreview';
import './styles/tokens.css';
import './styles/app.css';

const RootComponent = import.meta.env.VITE_DEMO_MODE === 'true' ? DemoPreview : App;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootComponent />
  </StrictMode>,
);
